import { render, staticRenderFns } from "./m-setting-content.vue?vue&type=template&id=3961c54a&scoped=true&"
import script from "./m-setting-content.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-setting-content.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-setting-content.vue?vue&type=style&index=0&id=3961c54a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3961c54a",
  null
  
)

export default component.exports